import { Flex } from '@chakra-ui/react';
import React from 'react';

import { WmdBanner } from '../../../../components/banners/wmd-banner/wmd-banner';
import { useSelectorPromoBannerConfig } from '../../../../configuration';
import {
    PromoBannerConfig,
    WmdPromoBannerConfig
} from './promo-banner.types';

export const PromoBanner = () => {
    const promoBannerConfig = useSelectorPromoBannerConfig();

    if (!promoBannerConfig || Object.keys(promoBannerConfig).length === 0) return null;

    function getActiveConfigKeys (config: PromoBannerConfig): string[] {
        const activeKeys: string[] = [];

        for (const key in config) {
            if (config[key]) {
                const section = config[key as keyof PromoBannerConfig];

                if (section && typeof section === 'object' && 'isActive' in section && section.isActive) {
                    activeKeys.push(key);
                }
            }
        }

        return activeKeys;
    }

    const activeConfigKeys = getActiveConfigKeys(promoBannerConfig);

    return (
        <Flex w={'100%'} justifyContent={'center'}>
            {activeConfigKeys.includes('wmd') && (
                <WmdBanner config={promoBannerConfig['wmd'] as WmdPromoBannerConfig} />
            )}
        </Flex>
    );
};
